export function getKategoriFromKode(kode) {
  const first = String(kode || "").trim().toUpperCase()[0] || "";
  if (first === "A") return "PRODUK UTAMA";
  if (first === "B") return "SOUVENIR DAN PACKAGING";
  if (first === "C") return "ADDITIONAL ITEM";
  return "";
}

export function getJenisFromKode(kode) {
  const raw = String(kode || "").trim();
  if (!raw) return "";

  const first = raw.toUpperCase()[0];
  if (first === "C") {
    // Excel: INDEX(SPLIT(A4,"-"),2)
    // JS: split[1]
    const parts = raw.split("-");
    return (parts[1] || "").trim();
  }

  // Excel: MID(A4;3;2) (1-based) => JS slice(2,4)
  return raw.slice(2, 4).trim();
}

export function getSeriFromKode(kode) {
  const raw = String(kode || "").trim();
  if (!raw) return "-";

  const first = raw.toUpperCase()[0];
  const parts = raw.split("-").map((p) => p.trim()).filter(Boolean);

  if (first === "A") {
    // Excel: between 2nd and 3rd '-' => parts[2]
    return parts[2] || "-";
  }

  // Excel: RIGHT(LEN - FIND 2nd '-') => everything after 2nd '-'
  return parts.slice(2).join("-") || "-";
}

export function getSizeFromKode(kode) {
  const raw = String(kode || "").trim();
  if (!raw) return "-";

  const first = raw.toUpperCase()[0];
  if (first !== "A") return "-";

  const parts = raw.split("-").map((p) => p.trim()).filter(Boolean);
  return parts[3] || "-";
}
